import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Actions from "../../../components/Common/Actions";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/Breadcrumbs";
import FilledButton from "../../../components/Common/Buttons/FilledButton";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import { convertSlugToNormalString } from "../../../components/Constants";
import ListPageLayout from "../../../components/Layout";
import Deletepopup from "../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../components/Utils/hooks/useSortHandler";

const DoctorslocalitiesList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cityPath = location.pathname.split("/")[2];
  const queryParams = new URLSearchParams(location.search);
  const cityId = queryParams.get("city_id");

  const addNewLocality = {
    id: "addnewlocality",
    onClick: () => navigate(`/${cityPath}/add-locality?city_id=${cityId}`),
    style: { width: "240px" },
    label: "Add New Localities",
  };

  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}locality/list/${cityId}`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler("locality", fetchData, setShowDelete);

  useEffect(() => {
    if (cityId) {
      fetchData();
    }
  }, [pagination.skip, pagination.limit, sort, search, cityId]);

  const handleEdit = (id) => {
    navigate(`/${cityPath}/edit-locality/${id}?city_id=${cityId}`);
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Localities",
      dataIndex: "locality",
      key: "locality",
      width: 200,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isEdit={true}
          isDelete={true}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickEdit={() => handleEdit(record._id)}
        />
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  const breadcrumbsList = [
    { text: "Doctor", link: "/partnered-doctor-online" },
    { text: convertSlugToNormalString(cityPath), link: "/doctors-location" },
    { text: "View Localities", link: "" },
  ];

  return (
    <ListPageLayout
      breadcrumbs={
        <Breadcrumbs
          className="healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={<FilledButton props={addNewLocality} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable medicineList_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
    >
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default DoctorslocalitiesList;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router";
// import search from "../../../assets/images/searchIcon.png";
// import apiCall from "../../../components/Api";
// import Breadcrumbs from "../../../components/Common/Breadcrumbs/Breadcrumbs";
// import Actions from "../../../components/Common/actions";
// import AddButton from "../../../components/Common/addButton";
// import FilterOptions from "../../../components/Common/filterOptions";
// import Pagination from "../../../components/Common/pagination";
// import Deletepopup from "../../../components/Modal/Deletepopup";

// const DoctorslocalitiesList = () => {
//   const [localityList, setLocalityList] = useState([]);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const cityPath = location.pathname.split("/")[2];
//   const queryParams = new URLSearchParams(location.search);
//   const cityId = queryParams.get("city_id");

//   useEffect(() => {
//     cityId && getCityList();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [cityId]);

//   const getCityList = async () => {
//     const result = await apiCall(`locality/list/${cityId}`, "GET");
//     if (result?.data) {
//       setLocalityList(result.data);
//       // setSuccess(true);
//     }
//   };
//   const handleLocationForm = () => {
//     navigate(`/${cityPath}/add-locality?city_id=${cityId}`);
//   };
//   const handleEdit = (id) => {
//     navigate(`/${cityPath}/edit-locality/${id}?city_id=${cityId}`);
//   };

//   const [del, setDel] = useState(false);
//   const [id] = useState("");

//   const handleDelete = (id) => {
//     fetch(
//       `${process.env.REACT_APP_API_URL}doctor-cities/${cityPath}/${id}/delete-locality`,
//       {
//         method: "DELETE",
//       },
//     ).then((result) => {
//       result.json().then((res) => {
//         // list_api_call();
//         setDel(false);
//       });
//     });
//   };

//   const [pages] = useState(0);
//   const [current_page, setCurrentPage] = useState(1);
//   const [, setSkip] = useState(0);
//   const [limit, setLimit] = useState(10);
//   const [sortName] = useState("Sort by");

//   const [sortshow, setSortShow] = useState(false);
//   const [, setFilterShow] = useState(false);

//   useEffect(() => {
//     if (current_page > 1) {
//       setSkip((current_page - 1) * limit);
//     } else {
//       setSkip(0);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [current_page]);

//   const capitalizeFirstLetter = (string) => {
//     return string.charAt(0).toUpperCase() + string.slice(1);
//   };

//   return (
//     <>
//       <DoctorslocalitiesListOld />
//       <div className="healtharticle">
//         <div className="healtharticle-container">
//           <div className="healtharticle-title carrer-job-title ms-4">
//             <Breadcrumbs
//               breadcrumbText="Doctor"
//               breadcrumbLink=""
//               nestedText={capitalizeFirstLetter(cityPath)}
//               nestedLink=""
//               nestedText2="View Localities"
//               nestedLink2=""
//             />
//           </div>
//           <div className="healtharticle-addnew gap-4">
//             <AddButton
//               onClick={handleLocationForm}
//               btnName="Add New Localities"
//             />
//           </div>
//           <FilterOptions
//             limit={limit}
//             sortshow={sortshow}
//             sortName={sortName}
//             search={search}
//             setFilterShow={setFilterShow}
//             setSortShow={setSortShow}
//             // filter_records={filter_records}
//             setLimit={setLimit}
//           />

//           <div className="healtharticle-table master-doctor-table">
//             <table>
//               <thead>
//                 <tr>
//                   <td className="career-jobpost-td1">S.No</td>
//                   <td className="career-jobpost-td2">Localities</td>
//                   <td className="career-jobpost-td12">Actions</td>
//                 </tr>
//               </thead>
//               <tbody>
//                 {localityList?.map((el, i) => {
//                   return (
//                     <tr key={i}>
//                       {/* <td>{(current_page - 1) * limit + (i + 1)}</td> */}
//                       <td>{(current_page - 1) * limit + (i + 1)}</td>
//                       <td>{el.locality}</td>
//                       <td>
//                         <Actions
//                           isView={false}
//                           isActive={false}
//                           isDelete={false}
//                           onClickEdit={() => handleEdit(el?._id)}
//                         />
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//       <Pagination
//         setCurrentPage={setCurrentPage}
//         current_page={current_page}
//         pages={pages}
//       />
//       {del === true && <Deletepopup handleDelete={handleDelete} id={id} />}
//     </>
//   );
// };

// export default DoctorslocalitiesList;

// const DoctorslocalitiesListOld = () => {
//   const [cityList, setCityList] = useState([]);

//   const navigate = useNavigate();
//   const pathName = useLocation();
//   const cityPath = pathName.pathname.split("/")[2];

//   useEffect(() => {
//     cityPath && getCityList();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [cityPath]);

//   const getCityList = () => {
//     axios
//       .get(`${process.env.REACT_APP_API_URL}doctor-cities/${cityPath}`)
//       .then((response) => {
//         setCityList(response?.data);
//       });
//   };

//   const handleLocationForm = () => {
//     navigate(`/doctors-localities-list/${cityList?.slug_url}`);
//   };
//   const [current_page] = useState(1);
//   const [limit] = useState(10);

//   const capitalizeFirstLetter = (string) => {
//     return string.charAt(0).toUpperCase() + string.slice(1);
//   };

//   return (
//     <>
//       <div className="healtharticle">
//         <div className="healtharticle-container">
//           <div className="healtharticle-title carrer-job-title ms-4">
//             <Breadcrumbs
//               breadcrumbText="Doctor"
//               breadcrumbLink=""
//               nestedText={capitalizeFirstLetter(cityPath)}
//               nestedLink=""
//               nestedText2="View Localities (Old)"
//               nestedLink2=""
//             />
//           </div>
//           <div className="healtharticle-addnew gap-4">
//             <AddButton
//               onClick={handleLocationForm}
//               btnName="Add / Edit New Localities"
//             />
//           </div>
//           <div className="healtharticle-table master-doctor-table">
//             <table>
//               <thead>
//                 <tr>
//                   <td className="career-jobpost-td1">S.No</td>
//                   <td className="career-jobpost-td2">Localities</td>
//                 </tr>
//               </thead>
//               <tbody>
//                 {cityList?.localities?.split(",")?.map((el, i) => {
//                   return (
//                     <tr key={i}>
//                       <td>{(current_page - 1) * limit + (i + 1)}</td>
//                       <td>{el}</td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
